(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mt-subscribe-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-subscribe-popup')) {
    customElements.define('mt-subscribe-popup', class extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('[data-sp-overlay]');
        this.dialog = this.querySelector('[data-sp-dialog]');
        this.tab = this.querySelector('[data-sp-tab]');
        this.form = this.querySelector('.mt-subpop__form');
        this.key = this.dataset.key || 'mt-subpop';
        this.designMode = this.dataset.designMode === 'true';

        this.querySelectorAll('[data-sp-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.overlay.addEventListener('click', () => this.close());
        this.querySelectorAll('[data-sp-open]').forEach((b) => b.addEventListener('click', () => this.open()));
        var tabClose = this.querySelector('[data-sp-tab-close]');
        if (tabClose) tabClose.addEventListener('click', () => { this.store('session', 'tab-hidden', '1'); this.showTab(false); });
        if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
        var copy = this.querySelector('[data-sp-copy]');
        if (copy) copy.addEventListener('click', () => this.copyCode(copy));
        var apply = this.querySelector('[data-sp-apply]');
        if (apply) apply.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = '/discount/' + apply.dataset.spApply + '?redirect=' + encodeURIComponent(new URL(apply.href, window.location.origin).pathname);
        });

        this.onKey = (e) => {
          if (!this.classList.contains('is-open')) return;
          if (e.key === 'Escape') this.close();
          if (e.key === 'Tab') this.trapFocus(e);
        };
        document.addEventListener('keydown', this.onKey);

        if (this.designMode) {
          this.addEventListener('shopify:section:select', () => this.open());
          this.addEventListener('shopify:section:deselect', () => this.close(true));
          this.showTab(true);
          return;
        }
        this.init();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        clearTimeout(this.timer);
      }

      store(type, name, value) {
        var area = type === 'session' ? window.sessionStorage : window.localStorage;
        var k = this.key + ':' + name;
        try {
          if (value === undefined) return area.getItem(k);
          if (value === null) area.removeItem(k);
          else area.setItem(k, value);
        } catch (e) { return null; }
      }

      init() {
        if (this.store('session', 'pending') && !/\/challenge/.test(window.location.pathname)) {
          this.store('session', 'pending', null);
          var serverError = this.querySelector('[data-sp-server-error]');
          var posted = this.querySelector('[data-sp-posted]') || /customer_posted=true/.test(window.location.search);
          if (serverError || posted) {
            this.open();
            if (serverError) this.showError(serverError.textContent.trim());
            else this.showSuccess();
            return;
          }
        }
        if (this.store('local', 'subscribed')) return;
        var closedAt = Number(this.store('local', 'closed-at') || 0);
        var days = Number(this.dataset.days || 0);
        var recentlyClosed = closedAt && Date.now() - closedAt < days * 864e5;
        if (recentlyClosed || this.store('session', 'closed')) {
          if (!this.store('session', 'tab-hidden')) this.showTab(true);
          return;
        }
        var delay = Math.max(0, Number(this.dataset.delay || 0)) * 1000;
        this.timer = setTimeout(() => this.autoOpen(), delay);
      }

      autoOpen() {
        var busy = document.querySelector('cart-drawer.is-open') || document.body.style.overflow === 'hidden';
        if (busy) { this.timer = setTimeout(() => this.autoOpen(), 3000); return; }
        this.open();
      }

      showTab(show) {
        if (this.tab) this.tab.hidden = !show;
      }

      open() {
        clearTimeout(this.timer);
        this.lastFocus = document.activeElement;
        this.overlay.hidden = false;
        this.dialog.hidden = false;
        this.showTab(false);
        requestAnimationFrame(() => this.classList.add('is-open'));
        this.prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        var input = this.dialog.querySelector('input[type="email"]');
        setTimeout(() => (input && !this.done ? input : this.dialog).focus({ preventScroll: true }), 60);
      }

      close(silent) {
        if (this.dialog.hidden) return;
        this.classList.remove('is-open');
        document.documentElement.style.overflow = this.prevOverflow || '';
        setTimeout(() => { this.overlay.hidden = true; this.dialog.hidden = true; }, 250);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
        if (silent || this.designMode) { if (this.designMode) this.showTab(true); return; }
        if (this.done) return;
        this.store('local', 'closed-at', String(Date.now()));
        this.store('session', 'closed', '1');
        if (!this.store('session', 'tab-hidden')) this.showTab(true);
      }

      trapFocus(e) {
        var items = Array.from(this.dialog.querySelectorAll('a[href], button, input')).filter((el) => !el.disabled && el.offsetParent !== null);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      showSuccess() {
        this.done = true;
        this.store('local', 'subscribed', '1');
        this.showTab(false);
        this.querySelector('[data-sp-step="form"]').hidden = true;
        this.querySelector('[data-sp-step="success"]').hidden = false;
        this.dialog.focus({ preventScroll: true });
      }

      showError(message) {
        var err = this.form && this.form.querySelector('[data-sp-error]');
        if (!err) return;
        err.textContent = message || this.dataset.error || 'Something went wrong. Please try again.';
        err.hidden = false;
      }

      submit(e) {
        if (this._submitting) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!this.form.reportValidity()) return;
        this._submitting = true;
        var btn = this.form.querySelector('[data-sp-submit]');
        var error = this.form.querySelector('[data-sp-error]');
        if (error) error.hidden = true;
        if (btn) btn.classList.add('is-loading');
        this.store('session', 'pending', '1');
        var go = () => { this.form.submit(); };
        var captcha = window.Shopify && window.Shopify.captcha;
        if (captcha && typeof captcha.protect === 'function') captcha.protect(this.form, go);
        else go();
      }

      copyCode(btn) {
        var code = this.querySelector('[data-sp-code]').textContent.trim();
        var done = () => { var t = btn.textContent; btn.textContent = btn.dataset.copied || 'Copied'; setTimeout(() => { btn.textContent = t; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
        else done();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
